import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Emits when the session is no longer valid (e.g. HTTP 401 after token clear).
 * Root layout or an `AuthService` can redirect to login.
 */
@Injectable({ providedIn: 'root' })
export class AuthEventsService {
  private readonly unauthorized = new Subject<void>();
  /** Stream of unauthorized events (e.g. 401 from API). */
  readonly unauthorized$ = this.unauthorized.asObservable();

  emitUnauthorized(): void {
    this.unauthorized.next();
  }
}
